export default "__VITE_ASSET__29c010dd__"